import { useState, useEffect, useCallback } from "react";
import { auth } from "../services/firebase-config";

let cachedUser = null;
let cachedClaims = {};
let lastFetched = 0;
const CACHE_DURATION = 60000; // 60 seconds

const useAuth = () => {
  const [user, setUser] = useState(cachedUser);
  const [customClaims, setCustomClaims] = useState(cachedClaims);
  const [loading, setLoading] = useState(!cachedUser);

  const fetchAuthData = async (currentUser, forceRefresh = false) => {
    if (!currentUser) {
      cachedUser = null;
      cachedClaims = {};
      setUser(null);
      setCustomClaims({});
      setLoading(false);
      return;
    }

    // Always refresh on auth state changes (initial fetch), cache only otherwise
    const shouldRefresh = forceRefresh => 
      forceRefresh || Date.now() - lastFetched > CACHE_DURATION;

    setLoading(true);
    try {
      const idTokenResult = await currentUser.getIdTokenResult(true);
      cachedUser = currentUser;
      cachedClaims = idTokenResult.claims || {};
      lastFetched = Date.now();

      setUser(cachedUser);
      setCustomClaims(cachedClaims);
    } catch (error) {
      console.error("⚠️ Error fetching custom claims:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    // Always refresh fresh data immediately on auth state change
    const unsubscribe = auth.onAuthStateChanged(currentUser => {
      fetchAuthData(currentUser, true); // force refresh
    });

    return () => unsubscribe();
  }, []);

  return {
    user,
    customClaims,
    loading,
    lastFetched,
    refetchAuth: useCallback(async () => {
      await fetchAuthData(auth.currentUser, true);
    }, []),
  };
};

export default useAuth;

